import { useEffect } from 'react';

const useGoogleAnalytics = () => {
  useEffect(() => {
    if (window.HIDE_ANALYTICS) return;

    if (document.getElementById('google-analytics')) return; // prevent duplicates

    const script = document.createElement('script');
    script.id = 'google-analytics';
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-G2KXG2DJJ2';
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'G-G2KXG2DJJ2');
    };
  }, []);
};

export default useGoogleAnalytics;
